import { Box, Button, Grid, Typography } from '@barracuda-internal/bds-core-v2';

function Welcome({ setStep, activeStep }) {
	return (
		<>
			<Typography
				variant="h1"
				color="textPrimary"
				gutterBottom
				sx={{ marginTop: '32px' }}
			>
				Welcome to Data Inspector!
			</Typography>
			<Typography
				variant="subtitle1"
				gutterBottom
				sx={{ marginTop: '16px' }}
			>
				Barracuda Data Inspector enables you to identify sensitive and
				malicious data that may exist in your environment.
			</Typography>

			<Typography
				variant="subtitle1"
				gutterBottom
				sx={{ marginTop: '16px' }}
			>
				In order to do that, Barracuda Data Inspector needs to access
				your organization's data, which includes information about all
				users, files, and activity stored in data sources you explicitly
				authorize the product to access.
			</Typography>
			<Typography
				variant="subtitle1"
				gutterBottom
				sx={{ marginTop: '16px' }}
			>
				Data inspector does not keep or modify your data but does keep
				meta-data such as redactions, events and policy violations.
				Barracuda Data Inspector will retain this meta-data for as long
				as you use the product.
			</Typography>
			<Box sx={{ marginTop: '24px' }}>
				<Grid container direction="row" spacing={1} alignItems="center">
					<Grid item xs={10}></Grid>
					<Grid item xs={2}>
						<Button
							size="large"
							onClick={() => {
								setStep(activeStep + 1);
							}}
						>
							Next
						</Button>
					</Grid>
				</Grid>
			</Box>
		</>
	);
}

export default Welcome;
